'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Action = require('../Action');

require('@deskpro/apps-components-style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Menu = function Menu(_ref) {
  var className = _ref.className,
      children = _ref.children,
      isOpen = _ref.isOpen,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)("dp-Menu", className) },
    _react2.default.createElement('i', { className: 'dp-IconSettings', onClick: onClick }),
    _react2.default.createElement(
      _Action.ActionList,
      { orientation: "vertical", className: '' + (isOpen ? '' : 'dp---is-hidden') },
      children
    )
  );
};

Menu.propsType = {

  classname: _propTypes2.default.string,

  type: _propTypes2.default.string,

  isOpen: _propTypes2.default.bool,

  onClick: _propTypes2.default.func
};

Menu.defaultProps = {

  isOpen: false
};

exports.default = Menu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Menu/Menu.js
// module id = 341
// module chunks = 0